document.addEventListener('alpine:init', () => {
  Alpine.data('CartNote', () => {
    return {
      updating: false,
      note: '',
      init() {
        this.note = this.$root.value;
        this.$watch('note', (value, oldValue) => {
          if (value !== oldValue) {
            this.updateNote();
          }
        });
      },
      async updateNote() {
        this.updating = true;

        await fetch(theme.routes.cart_update_url, {
          ...fetchConfigDefaults(),
          body: JSON.stringify({
            note: this.$root.value,
          }),
        });

        this.updating = false;
      },
    };
  });
});

/* Monolith cart note for terms and conditions checkbox */
document.addEventListener('DOMContentLoaded', function () {
  const checkoutButton = document.querySelector('[name="checkout"], [data-cart-drawer] button[type="submit"]');
  const checkbox = document.getElementById('termsCheckbox');

  if (checkoutButton && checkbox) {
    checkoutButton.addEventListener('click', function (e) {
      if (!checkbox.checked) {
        e.preventDefault();
        alert('Please agree to the terms and conditions before proceeding to checkout.');
      } else {
        // Update cart note to track agreement
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify({
            note: 'Agreed to terms and conditions for digital services.'
          })
        }).then(() => {
          setTimeout(() => {
            window.location.href = '/checkout';
          }, 300);
        });

        e.preventDefault(); // Stop default checkout for manual redirect
      }
    });
  }
});
/* End Monolith cart note for terms and conditions checkbox */
